import { createSlice } from "@reduxjs/toolkit";
import { streamSnapshotAction, streamTradesAction } from "../../actions/realtimeAction";

const initialState = {
  snapshot: {},
  trades: {},
};

const realtimeSlice = createSlice({
  name: "realtime",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(streamSnapshotAction.fulfilled, (state, action) => {
      state.snapshot[action.payload.id] = action.payload;
    });
    builder.addCase(streamTradesAction.fulfilled, (state, action) => {
      state.trades[action.payload.id] = action.payload;
    })
  },
});

export default realtimeSlice;

/**
 * 
 * @param {*} state 
 * @returns { import("../../..").ISnapshotData }
 */
export const stockSnapshotSelector = (state) => state?.realtime?.snapshot

/**
 * 
 * @param {*} state 
 * @returns { import("../../..").ITradesData }
 */
export const stockTradesSelector = (state) => state?.realtime?.trades